import { createFeature, createReducer, on } from '@ngrx/store';
import { IdentiteImmatriculeeDetail } from '@idt-api';
import { IdtActions } from './idt.actions';

const IDT_FEATURE_KEY = 'idt';

export interface State {
  identite: IdentiteImmatriculeeDetail | null;
  loading: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any | null;
}

export const initialIdtState: State = {
  identite: null,
  loading: false,
  error: null,
};

export const idtFeature = createFeature({
  name: IDT_FEATURE_KEY,
  reducer: createReducer(
    initialIdtState,
    on(IdtActions.lireIdentite, (state) => ({
      ...state,
      loading: true,
      error: null,
    })),
    on(IdtActions.lireIdentiteSuccess, (state, action) => ({
      ...state,
      identite: action.identite,
      loading: false,
      error: null,
    })),
    on(IdtActions.lireIdentiteFailure, (state, action) => ({
      ...state,
      loading: false,
      error: action.error,
    })),
  ),
});
